import * as Dialog from '@radix-ui/react-dialog'
import {
  type ComponentPropsWithoutRef,
  type ElementRef,
  forwardRef,
} from 'react'
import { Spacing } from '@opallabs/gem'
import { Icon } from '../Icon'
import * as styles from './styles'

export type TitleProps = Readonly<
  ComponentPropsWithoutRef<typeof Dialog.Title> & {
    leadingIconGlyph?: string
  }
>
/**
 * @note This **MUST NOT** be rendered inside Modal `<Body>`; its spacing (margins etc) within Modal `<Content>` depends
 * on it being a sibling to `<Body>`.
 */
export const Title = forwardRef<ElementRef<typeof Dialog.Title>, TitleProps>(
  (props, forwardedRef) => {
    const { children, leadingIconGlyph, ...otherProps } = props
    return (
      <div
        {...otherProps}
        className={styles.classes.title}
        css={styles.modalTitle}
      >
        {leadingIconGlyph && (
          <Icon
            ariaHidden
            className={styles.classes.titleIcon}
            glyph={leadingIconGlyph}
            height={Spacing.L}
            width={Spacing.L}
          />
        )}
        <Dialog.Title className={styles.classes.titleText} ref={forwardedRef}>
          {children}
        </Dialog.Title>
      </div>
    )
  }
)
Title.displayName = 'Lapidary: Title ← Modal'
